<div class="p-grid main-edit-vehiculo-movil">
  <div class="p-col-10 m-auto">
      <div class="p-d-flex p-jc-center" *ngIf="!sinPermiso">
          <h4 class="p-mx-5 p-mt-5">{{'VEHICULO.EDITAR' | translate}}</h4>
      </div>
      <div *ngIf="sinPermiso">
        <h3 class="alerta-permiso" > {{'GLOBAL.SIN.PERMISOS.VEHICULO' |translate}} <br/> <i class="pi pi-exclamation-triangle" style="font-size: 2rem"></i></h3>
      </div>
      <form class="" name="registroVehiculoForm" #registroVehiculoForm="ngForm" *ngIf="vehiculo">
          <div class="p-grid">
              <div class="p-col-12 p-md-6 p-mt-3">
                  <span class="ui-float-label">
                    <input class="w-100" #matricula="ngModel" id="matricula" type="text" pInputText [(ngModel)]="vehiculo.matricula " required name="matricula">
                    <label for="float-input">{{'GLOBAL.MATRICULA' | translate}}</label>
                 </span>
                  <small *ngIf="(matricula.dirty && matricula.invalid) " class="p-error">{{'REGISTRO.MATRICULA.OBLIGATORIO' | translate}}</small>
                  <small *ngIf="(mensajeErrorMatricula) " class="p-invalid">{{'REGISTRO.ERROR.MATRICULA' | translate}}</small>
              </div>
              <div class="p-col-12 p-md-6 p-mt-3">
                  <span class="ui-float-label">
          <input class="w-100" #peso="ngModel" id="peso" type="number"  pInputText [(ngModel)]="vehiculo.peso " required name="peso ">
          <label for="float-input">{{'GLOBAL.PESO' | translate}}</label>
      </span>
                  <small *ngIf="(peso.dirty && peso.invalid) " class="p-invalid">{{'REGISTRO.PESO.OBLIGATORIO' | translate}}</small>
              </div>
          </div>
          <div class="p-grid">
              <div class="p-col-12 p-md-6 p-mt-2">
                  <label for="tipoVehiculo">{{'VEHICULO.TIPO' | translate}}</label>
                  <p-dropdown [style]="{'width':'100%'}" id="tipoVehiculo" [required]="true" [options]="tipoVehiculos" [(ngModel)]="vehiculo.tipoVehiculo" name="tipoVehiculo" [placeholder]="'VEHICULO.TIPO' | translate" optionLabel="nombre"></p-dropdown>
              </div>
              <div class="p-col-12 p-md-6 p-mt-1">
                  <label for="distintivoAmbiental">{{'VEHICULO.DISTINTIVO.AMBIENTAL' | translate}}
                    <a href="https://sede.dgt.gob.es/es/vehiculos/distintivo-ambiental/" target="_blank">
                        <i class="fas fa-info-circle" pTooltip="Información Distintivo Ambiental" tooltipPosition="top"></i>
                    </a>
                  </label>
                  <p-dropdown [style]="{'width':'100%'}" id="distintivoAmbiental" [required]="true" [options]="distintivosAmbientales" [(ngModel)]="vehiculo.distintivoAmbiental" [placeholder]="'VEHICULO.DISTINTIVO.AMBIENTAL' | translate" name="distintivoAmbiental" optionLabel="nombre"></p-dropdown>
              </div>
          </div>
          <div class="p-grid">
              <div class="p-col-12 p-md-6  p-mt-2">
                  <label for="clasificacionVehiculo">{{'VEHICULO.CLASIFICACION' |translate}}</label>
                  <p-dropdown [style]="{'width':'100%'}" id="clasificacionVehiculo" [required]="true" [options]="clasificacionVehiculos" [(ngModel)]="vehiculo.clasificacionVehiculo" [placeholder]="'VEHICULO.CLASIFICACION' |translate" name="clasificacionVehiculo" optionLabel="descripcion"></p-dropdown>
              </div>
              <div class="p-col-12 p-md-6 p-mt-1">
                  <label for="tipoCombustible">{{'VEHICULO.TIPO.COMBUSTIBLE'|translate}}</label>
                  <p-dropdown [style]="{'width':'100%'}" id="tipoCombustible" [required]="true" [options]="tiposCombustible" [(ngModel)]="vehiculo.tipoCombustible" [placeholder]="'VEHICULO.TIPO.COMBUSTIBLE'|translate" name="tipoCombustible" optionLabel="nombre"></p-dropdown>
              </div>
          </div>
          <div class="p-grid">
              <div class="p-col-12 p-md-6 p-mt-2">
                  <label for="usoVehiculo">{{'VEHICULO.USO' | translate}}</label>
                  <p-dropdown [style]="{'width':'100%'}" id="usoVehiculo" [required]="true" [options]="usosVehiculos" [(ngModel)]="vehiculo.usoVehiculo" [placeholder]="'VEHICULO.USO' | translate" name="usoVehiculo" optionLabel="nombre"></p-dropdown>
              </div>
              <div class="p-col-12 p-md-6 p-mt-1">
                  <label for="sector">{{'VEHICULO.SECTOR' | translate}}</label>
                  <p-dropdown [style]="{'width':'100%'}" id="sector" [required]="true" [options]="sectores" [(ngModel)]="vehiculo.sector" [placeholder]="'VEHICULO.SECTOR' | translate" name="sector" optionLabel="nombre"></p-dropdown>
              </div>
          </div>
          <div class="p-grid">
            <div class="p-col-12 p-mt-2">
              <h5>{{'GLOBAL.USUARIO.AUTORIZADO' |translate}}</h5>
                  <div class="p-d-flex">
                      <input class="w-75"  type=" text " name="usuarioAutorizado" pInputText placeholder="Introduzca el DNI " [(ngModel)]="newDniUsuarioAutorizado">
                      <button class="w-25" type="button" pButton pRipple [label]="'GLOBAL.AÑADIR'|translate" (click)="autorizarUsuarioVehiculo()"></button>
                  </div>
                  <p-dataView [value]="listUsuariosAuth" layout="list" [emptyMessage]="'VEHICULOS.NO.USUARIO.AUTORIZADO' | translate">
                    <p-header>
                      <div class="p-d-flex p-jc-between">
                          <div class="p-col-5 p-d-flex p-jc-center">{{'GLOBAL.DNI' |translate}}</div>
                          <div class="p-col-5 p-d-flex p-jc-center"> {{'GLOBAL.ELIMINAR' |translate}}</div>
                      </div>
                  </p-header>
                  <ng-template let-dni let-ri="rowIndex" pTemplate="listItem">
                    <div class="p-col-5 p-d-flex p-jc-center">{{dni.dni}}</div>
                    <div class="p-col-5 p-d-flex p-jc-end">
                      <button pButton pRipple icon="pi pi-trash" class="p-button-rounded p-button-warning" [pTooltip]="'GLOBAL.ELIMINAR' | translate" tooltipPosition="top" (click)="deleteUsuarioAutorizado(dni)"></button>
                  </div>
                  </ng-template>
                  </p-dataView>
              </div>
          </div>
          <div class="p-grid p-mb-2 p-mt-2">
            <div class="p-col-12">
                <h5>{{'VEHICULO.DOCUMENTOS' |translate}}</h5>
                <p-dataView [value]="documentos" layout="list" [emptyMessage]="'VEHICULOS.AÑADA.DOCUMENTOS' | translate">
                    <p-header>
                        <div class="p-d-flex p-jc-between">
                            <div class="p-col-4">{{'GLOBAL.TIPO' |translate}}</div>
                            <div class="p-col-4">{{'GLOBAL.ARCHIVO' |translate}}</div>
                        </div>
                    </p-header>
                    <ng-template let-documento let-ri="rowIndex" pTemplate="listItem">
                        <div class="p-col-12 p-d-flex p-jc-between p-2 documento-list" *ngIf="ri !== documentos.length -1">
                            <div class="p-col-5">{{documento.tipoDocumento.nombre}}</div>
                            <div class="p-col-2">
                                <button pButton *ngFor="let imagen of documento.imagenes" icon="fas fa-file"  class="p-button-rounded p-button-warning p-mb-2 w-75" [pTooltip]="imagen.nombre" tooltipPosition="top" (click)="downloadDocument(imagen)"></button>
                            </div>
                            <div class="p-col-2">
                                <button pButton pRipple icon="pi pi-trash" class="p-button-rounded p-button-warning" [pTooltip]="'GLOBAL.ELIMINAR' | translate" tooltipPosition="top" (click)="deleteDocumento(documento)"></button>
                            </div>
                        </div>
                        <div class="p-col-12 p-d-flex p-jc-between p-2 p-ai-center" *ngIf="ri === documentos.length -1">
                            <div class="p-col-5">{{documento.tipoDocumento.nombre}}</div>
                            <div class="p-col-2">
                                <button pButton *ngFor="let imagen of documento.imagenes" icon="fas fa-file"  class="p-button-rounded p-button-warning p-mb-2 w-75" [pTooltip]="imagen.nombre" tooltipPosition="top" (click)="downloadDocument(imagen)"></button>
                            </div>
                            <div class="p-col-2">
                                <button pButton pRipple icon="pi pi-trash" class="p-button-rounded p-button-warning" [pTooltip]="'GLOBAL.ELIMINAR' | translate" tooltipPosition="top" (click)="deleteDocumento(documento)"></button>
                            </div>
                        </div>
                    </ng-template>
                    <p-footer class="p-d-flex p-jc-end">
                        <div class="p-col-6 p-d-flex p-jc-end">
                            <button pButton icon="pi pi-plus" class="p-button-rounded p-button-warning w-25" [pTooltip]="'GLOBAL.AÑADIR' | translate" tooltipPosition="top" (click)="addDocumento()"></button>
                        </div>
                    </p-footer>
                </p-dataView>
                <p>{{'REGISTRO.DOCUMENTOS.OBLIGATORIOS' | translate}}</p> <br>
            </div>
        </div>
          <div class="p-grid p-mt-2">
              <div class="p-col-12 p-md-6">
                  <button class="pr-2 pl-2 pb-1 pt-1 w-100" type="submit " [disabled]="(registroVehiculoForm.form.invalid)" pButton [label]=" 'GLOBAL.GUARDAR' | translate " (click)="saveVehiculo()" ></button>
              </div>

          </div>
      </form>
  </div>
</div>

<p-dialog *ngIf="visibleAddDocumento" id="dialog-edit-movil" [(visible)]="visibleAddDocumento" [contentStyle]="{height: '100%'}" [style]="{width: '550px', height: '600px'}" [resizable]="false" [header]="'VEHICULO.AÑADIR.DOCUMENTO' | translate" [modal]="true">
  <form #formNewDocumento="ngForm">
      <div class="p-grid p-mb-5 p-mt-3">
          <div class="p-col-12 p-d-flex p-jc-center">
              <label class=" w-25 p-mr-2">{{'GLOBAL.TIPO.DOCUMENTO' |translate}}*</label>
              <p-dropdown class="w-75" name="tipoDocumentoNewDocumento" [options]="selectTiposDocumentos" required placeholder="Seleccionar" [(ngModel)]="tipoDocumentoNewDocumento" optionLabel="nombre" styleClass="w-100" (onChange)="resetearVariablesAddDocumentos()"></p-dropdown>
          </div>
          <div *ngIf="tipoDocumentoNewDocumento && (tipoDocumentoNewDocumento.id === 1 || tipoDocumentoNewDocumento.id === 3)" class="p-col-12 p-d-flex p-jc-center">
              <label class=" w-25 p-mr-2">{{'GLOBAL.FECHA.VENCIMIENTO' |translate}}*</label>
              <p-calendar class="w-75" name="fechaVencimientoNewDocumento" [locale]="localeCalendar" [minDate]="minDate" required [(ngModel)]="fechaVencimientoNewDocumento" styleClass="w-100" dateFormat="dd/mm/yy" inputId="spanish"></p-calendar>
          </div>
          <div class="p-col-12">
              <label for="">{{'GLOBAL.DOCUMENTOS' |translate}}*</label>
              <p-fileUpload name="nuevosDocumentos" [chooseLabel]="'GLOBAL.AÑADIR'|translate" [multiple]="true" [showUploadButton]="false" [accept]="acceptTypeDocument" [showCancelButton]="false" (onSelect)="addNewDocumento($event)"></p-fileUpload>
          </div>
          <div class="p-col-12 p-d-flex p-jc-center">
              <button pButton pRipple [label]="'GLOBAL.CANCELAR' | translate" icon="pi pi-times" class="p-button-text p-mr-3" (click)="cancelNewDocumento()"></button>
              <button pButton pRipple [label]="'GLOBAL.GUARDAR' | translate" icon="pi pi-check" [disabled]="(!tipoDocumentoNewDocumento || this.newDocumentos.length < 1) || ((tipoDocumentoNewDocumento.id === 1 || tipoDocumentoNewDocumento.id === 3 ) && (fechaVencimientoNewDocumento === undefined || fechaVencimientoNewDocumento ===null) )"
                  class="p-button-text" (click)="saveNewDocumento()"></button>
          </div>
          <p>{{'GLOBAL.CAMPOS.REQUERIDOS' |translate}}</p>
      </div>
  </form>
</p-dialog>
<dum-toast #dumToast></dum-toast>
